import type { DayTradeState } from '@/models/enums';

interface TradeStatusBadgeProps {
  state: DayTradeState;
}

const STATE_CONFIG: Record<DayTradeState, { label: string; className: string }> = {
  OPEN: {
    label: 'Offen',
    className: 'bg-blue-100 text-blue-800 dark:bg-blue-900/50 dark:text-blue-200 border-1 border-transparent',
  },
  GOAL_REACHED: {
    label: 'Ziel erreicht',
    className: 'bg-green-100 text-green-800 dark:bg-green-900/50 dark:text-green-200 border-1',
  },
  STOPPED: {
    label: 'Gestoppt',
    className: 'bg-gray-100 text-gray-800 dark:bg-gray-900/50 dark:text-gray-200 border-1',
  },
  STOPLOSS: {
    label: 'Stop-Loss',
    className: 'bg-red-100 text-red-800 dark:bg-red-900/50 dark:text-red-200 border-1',
  },
};

export default function TradeStatusBadge({ state }: TradeStatusBadgeProps) {
  const config = STATE_CONFIG[state];

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold ${config.className}`}
    >
      {config.label}
    </span>
  );
}
